<template>
  <div class='main-info-form'>
    <v-form ref="form">
      <div>
        <v-autocomplete
          :items="companiesToSuggest"
          :label="$t('registration.workspace.info.organization.name')"
          :placeholder="$t('registration.workspace.info.organization.name.placeholder')"
          item-text="name"
          item-value="domain"
          v-model="organizationName"
          @change="organizationNameChanged"
          @input.native="handleCompanySuggestionInput"
          dense
          :rules="[rules.required]"
          outlined
          autofocus
          return-object
        />
        <v-text-field
          :class="{ 'with-icon': companyLogo }"
          :label="$t('registration.workspace.info.domain')"
          :placeholder="$t('registration.workspace.info.domain.placeholder')"
          :rules="[rules.domain, rules.required]"
          outlined
          dense
          @input.native="emitFormChanged"
          v-model="organizationDomain"
        >
          <template v-slot:prepend-inner>
            <company-icon v-if="companyLogo" :url="companyLogo" />
          </template>
        </v-text-field>
        <v-autocomplete
          :items="amountOfEmployees"
          :label="$t('registration.workspace.info.employees')"
          :placeholder="$t('registration.workspace.info.employees.placeholder')"
          :rules="[rules.required]"
          item-value="amount"
          v-model="employeesNumber"
          @change="emitFormChanged"
          dense
          outlined
          return-object
        />
        <v-autocomplete
          :items="regions"
          :label="$t('registration.workspace.info.office.location')"
          :placeholder="$t('registration.workspace.info.office.location.placeholder')"
          :rules="[rules.required]"
          v-model="officeLocation"
          @change="emitFormChanged"
          dense
          outlined
          return-object
        />
      </div>
    </v-form>
  </div>
</template>

<script>
import { rules } from '@/utils/validationUtils';
import CompanyIcon from '@/components/Dashboard/CompanyIcon.vue';

export default {
  name: 'MainInfoForm',
  props: {
    regions: {
      type: Array,
      required: true,
    },
    amountOfEmployees: {
      type: Array,
      required: true,
    },
    companySuggestions: {
      type: Array,
      required: true,
    },
    companySuggestionsLoading: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  components: {
    CompanyIcon,
  },
  data() {
    return {
      officeLocation: this.value.officeLocation,
      employeesNumber: this.value.employeesNumber,
      organizationName: this.value.organizationName,
      organizationDomain: this.value.organizationDomain,
    };
  },
  computed: {
    rules() {
      return { ...rules, required: v => rules.required(v) || this.$t('required') };
    },
    companiesToSuggest() {
      return (this.companySuggestionInputValue
        ? [{ name: this.companySuggestionInputValue, domain: this.companySuggestionInputValue }]
        : []
      ).concat(this.companySuggestions);
    },
    companyLogo() {
      return this.organizationName?.logo;
    },
  },
  methods: {
    organizationNameChanged() {
      this.organizationDomain = this.organizationName?.domain;
      this.emitFormChanged();
    },
    handleCompanySuggestionInput(event) {
      this.companySuggestionInputValue = event.target.value;
      this.$emit('companySuggest', this.companySuggestionInputValue);
      this.emitFormChanged();
    },
    emitFormChanged() {
      this.$emit('changed', {
        officeLocation: this.officeLocation,
        employeesNumber: this.employeesNumber,
        organizationName: this.organizationName,
        organizationDomain: this.organizationDomain,
      });
    },
  },
  watch: {
    organizationDomain() {
      if (!this.organizationDomain) {
        this.organizationName.logo = null;
      }
    },
  },
};
</script>

<style lang="scss">
@import '~@/assets/styles/design-system';

.v-text-field--outlined.v-input--dense > .v-input__control > .v-input__slot {
  height: 32px;
}

.vue-tel-input-vuetify .v-text-field--outlined .v-select__selections .vti__flag {
  margin-left: 20px !important;
}

.vue-tel-input-vuetify .v-text-field .v-select__selections {
  position: relative;
  margin-left: 0 !important;

}

#app .v-text-field--outlined input {
  font-size: $font-size-base;
  color: $auth-text-primary;
  padding: 5px $space-3;
  text-overflow: ellipsis;
  padding-left: $space-2-5 !important;
}

.main-info-form {
  .v-input__icon--append {
    margin-top: 0px !important;
  }
  .v-input__prepend-inner{
    margin-top: $radius-3 !important;
    margin-left: $radius-3 !important;
  }
  .with-icon {
    .v-input__control {
      .v-input__slot {
        .v-label--active {
          left: -29px !important;
        }
      }
    }
  }
  .v-autocomplete {
    input {
      text-overflow: ellipsis;
    }
  }

  .v-text-field__suffix {
    color: $auth-text-primary;
    font-size: $font-size-base;
    letter-spacing: 0;
    line-height: $font-size-md;
    padding-right: $space-2-5;
  }

  .checkbox-title .v-btn {
    padding: 0px $radius-sm;
  }

  .checkbox-title .v-btn__content {
    color: $info-500;
    font-size: $font-size-base;
    letter-spacing: 0;
    line-height: $font-size-md;
    text-transform: capitalize;
  }
}
</style>

<style lang="scss" scoped>
.main-info-form {
  display: flex;
  flex-direction: column;
  min-width: 356px;

  .v-input--checkbox {
    margin-top: 0px;
  }

  .v-autocomplete {
    input {
      text-overflow: ellipsis;
    }

    .v-input__append-inner {
      margin-top: 0px;
    }
  }
}

.main-info-form-column {
  display: flex;
}

.left-input {
  margin-right: 8px;
}

.checkbox-title {
  display: flex;
  align-items: center;

  span {
    font-size: 14px;
    letter-spacing: 0;
    line-height: 16px;
  }
}
</style>
